<template>
  <div class="md:py-4 lg:py-6 xl:py-8 px-2 md:px-4 max-w-7xl mx-auto" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <Breadcrumb :title="'數位學習'" />
    <div>
      <a href="https://store.liveabc.com/products/magazine/sale?tag=92" class="block mb-4">
        <img src="@/assets/images/class3.jpg" alt="livaABC" class="w-full h-auto object-contain">
      </a>
    </div>
    <div class="mainapp">
      <div class="flex mb-6 md:mb-3 lg:mb-0">
        <div class="w-full lg:w-1/4 gradient">
          <div class="title text-white py-1 text-NotoSansRegular pl-4 lg:rounded-r-full text-xl">LiveABC 雜誌系列APP</div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4 gradient">
        </div>
        <div class="w-full lg:w-3/4 lg:pl-4">
        <!-- 5大互動功能 -->
          <h3 class="interact-intro text-2xl text-NotoSansBold textColorDarkBlack mb-4 hidden lg:block">5大互動功能</h3>
          <div class="hidden lg:flex flex-wrap w-full md:mb-4">
            <div class="w-1/3 flex mb-4" v-for="(item, index) in InteractiveFunction" :key="index">
              <div>
                <p class="text-NotoSansRegular textColorDarkBlack font-bold">{{ item.name }}</p>
                <p class="text-NotoSansRegular textColorDarkBlack">{{ item.text }}</p>
              </div>
              <img :src="item.img" :alt="item.name" class="ml-2 xl:ml-4 object-contain">
            </div>
          </div>
          <!-- LiveABC 雜誌系列APP -->
          <div class="flex flex-wrap mb-4">
            <div class="w-1/2 md:w-1/3 mb-8 px-3 md:px-2 flex flex-col justify-between" v-for="(item, index) in liveAppData" :key="index">
              <a :href="item.googlelink" class="cursor-pointer" target="_blank">
                <img v-lazy="item.img" :alt="item.name" class="mb-4 object-contain" :title="item.name">
                <p class="text-NotoSansRegular textColorDarkBlack text-sm font-bold">
                  {{ item.name }}
                </p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm">{{ item.grade }}</p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm hidden xl:block whitespace-pre-wrap" v-html="item.text">
                </p>
              </a>
              <div class="flex mt-2">
                <a :href="item.googlelink" target="_blank" v-if="item.googlelink !== ''" class="w-1/2">
                  <img src="@/assets/icon/device-google.png" alt="livaABC" class="h-full">
                </a>
                <a :href="item.ioslink" target="_blank" v-if="item.ioslink !== ''" class="w-1/2">
                  <img src="@/assets/icon/device-ios.png" alt="livaABC" class="h-full">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 線上平台 -->
      <div class="flex flex-wrap title-border pb-6 pd:mb-3 lg:pb-0">
        <div class="w-full lg:w-1/4 gradient">
          <div class="title text-white py-1 text-NotoSansRegular pl-4 lg:rounded-r-full text-xl">線上平台</div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/4 gradient">
        </div>
        <div class="w-full lg:w-3/4 lg:pl-4">
          <div class="flex flex-wrap md:mb-4">
            <div class="w-1/2 md:w-1/3 mb-8 px-3 md:px-2" v-for="(item, index) in onlinePlatform" :key="index">
              <router-link :to="{ name: 'SearchResult', query: { keyword: item.keyword } }"
                class="cursor-pointer" v-if="item.keyword">
                <img v-lazy="item.img" :alt="item.name" class="mb-4 object-contain" :title="item.name">
                <p class="text-NotoSansRegular textColorDarkBlack text-sm font-bold">
                  {{ item.name }}
                </p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm" v-html="item.text">
                </p>
              </router-link>
              <router-link :to="{ name: item.routerName }" target="_blank"
                class="cursor-pointer" v-if="item.routerName">
                <img v-lazy="item.img" :alt="item.name" class="mb-4 object-contain" :title="item.name">
                <p class="text-NotoSansRegular textColorDarkBlack text-sm font-bold">
                  {{ item.name }}
                </p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm" v-html="item.text">
                </p>
              </router-link>
              <a :href="item.link" v-if="item.link" target="_blank"
                class="cursor-pointer">
                <img v-lazy="item.img" :alt="item.name" class="mb-4 object-contain" :title="item.name">
                <p class="text-NotoSansRegular textColorDarkBlack text-sm font-bold">
                  {{ item.name }}
                </p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm" v-html="item.text">
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 互動學習 APP -->
      <div class="flex flex-wrap title-border mb-6 md:mb-3 lg:mb-0">
        <div class="w-full lg:w-1/4 gradient">
          <div class="title text-white py-1 text-NotoSansRegular pl-4 lg:rounded-r-full text-xl">互動學習 APP</div>
        </div>
      </div>
      <div class="flex flex-wrap mb-4">
        <div class="w-full lg:w-1/4 gradient">
        </div>
        <div class="w-full lg:w-3/4 lg:pl-4">
          <div class="flex flex-wrap md:mb-4">
            <div class="w-1/2 md:w-1/3 mb-8 px-3 md:px-2 flex flex-col justify-between" v-for="(item, index) in interactiveApp" :key="index">
              <a :href="item.googlelink" class="cursor-pointer" target="_blank">
                <img v-lazy="item.img" :alt="item.name" class="mb-4 object-contain" :title="item.name">
                <p class="text-NotoSansRegular textColorDarkBlack text-sm font-bold">
                  {{ item.name }}
                </p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm hidden md:block" v-html="item.text"></p>
                <p class="text-NotoSansRegular textColorDarkBlack text-sm md:hidden" v-html="item.mobiletext"></p>
              </a>
              <div class="flex mt-2">
                <a :href="item.googlelink" target="_blank" v-if="item.googlelink !== ''" class="w-1/2">
                  <img src="@/assets/icon/device-google.png" alt="livaABC" class="h-full">
                </a>
                <a :href="item.ioslink" target="_blank" v-if="item.ioslink !== ''" class="w-1/2">
                  <img src="@/assets/icon/device-ios.png" alt="livaABC" class="h-full">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LiveABC電子書/雜誌這裡買 -->
    <div>
      <div class="px-3 md:px-0">
        <h3 class="text-2xl text-NotoSansRegular mb-3 font-bold textColorDarkBlack">LiveABC電子書/雜誌販售平台</h3>
        <h6 class="text-base text-NotoSansRegular mb-4 md::mb-8 textColorDarkBlack">各平台販售之商品/服務、閱讀器規格或使用方式依平台會有所不同，請依各平台網站揭示為準。</h6>
      </div>
      <div class="flex flex-wrap mb-4">
        <div class="w-1/3 md:w-1/6 flex flex-col items-center py-4 px-2" v-for="(item, index) in whereBuy" :key="index">
          <img v-lazy="item.img" :alt="item.name" class="mb-6 object-contain" :title="item.name">
          <p v-html="item.name" class="text-center text-NotoSansRegular textColorDarkBlack"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/modules/Breadcrumb'
export default {
  name: 'DigitalLearning',
  metaInfo () {
    return {
      title: '數位學習'
    }
  },
  data () {
    return {
      // 五大互動功能
      InteractiveFunction: [
        { img: require('@/assets/icon/1-movie-icon.svg'), name: '影片學習課程', text: '有聲有影學英語最有效' },
        { img: require('@/assets/icon/3-dictionary-icon.svg'), name: '字典査詢功能', text: '不懂的單字立刻査詢' },
        { img: require('@/assets/icon/5-Switch-icon.svg'), name: '中英字幕切換', text: '自由切換字幕加強聽' },
        { img: require('@/assets/icon/2-ebook-icon.svg'), name: '電子書籍頁面', text: '紙本雜誌版面分段朗讀' },
        { img: require('@/assets/icon/4-Phrase-icon.svg'), name: '重點單字片語', text: '課列出重點單字片語' }
      ],
      // 系列APP
      liveAppData: [
        { img: require('@/assets/icon/app-abc.png'), name: 'ABC互動英語', grade: '初級 基礎、活用', text: '終結英語初學的痛苦<br/>輕鬆戰勝全民英檢初級、國中會考', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.mgz.abc', ioslink: '' },
        { img: require('@/assets/icon/app-live.png'), name: 'Live互動英語', grade: '中級 生活、實用', text: '輕鬆開口說英語<br/>適用全民英檢中級、大學學測、統測', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.mgz.live', ioslink: '' },
        { img: require('@/assets/icon/app-all.png'), name: 'ALL+互動英語', grade: '中高級 進階、應用', text: '進階、應用<br/>俱基礎能力想再提升實力高中生、成人<br/>適用全民英檢中級以上、大學學測', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.mgz.allplus', ioslink: '' },
        { img: require('@/assets/icon/app-biz.png'), name: 'biz互動英語', grade: '職場 工作、商業', text: '快速提升職場競爭力<br/>適用全民英檢中級以上、TOEIC檢定', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.mgz.biz', ioslink: '' },
        { img: require('@/assets/icon/app-cnn.png'), name: 'CNN互動英語', grade: '新聞 時事、新知', text: '開啟英語世界的大門<br/>適用TOEIC、TOEFL考試準備者', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.mgz.cnn', ioslink: 'https://apps.apple.com/tw/app/cnn-breaking-us-world-news/id331786748' },
        { img: require('@/assets/icon/app-jp.png'), name: '互動日本語', grade: '日語 生活、實用', text: '俱備日常生活閱讀能力<br/>聽懂日常會話，基礎日語溝通沒問題', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.mgz.jpn', ioslink: '' }
      ],
      // 線上平台
      onlinePlatform: [
        { img: require('@/assets/icon/web-livetalk.png'), name: 'LiveTalk', text: '專業外師口說訓練<br/>LiveABC熱門教材', link: '', ioslink: '', keyword: '', id: '', routerName: 'liveTalk' },
        // { img: require('@/assets/icon/web-lttc.png'), name: 'LTTC', text: '全民英檢線上擬真模考<br/>LTTC官方授權試題', link: '', ioslink: '', keyword: 'LTTC', id: '', routerName: '' },
        { img: require('@/assets/icon/web-pigai.png'), name: '批改網', text: '英文寫作加分利器<br/>上傳文章立即批改', link: '', ioslink: '', keyword: '批改網', id: '', routerName: '' }
      ],
      // 互動學習 APP
      interactiveApp: [
        { img: require('@/assets/icon/app-live-speaking.png'), name: 'Live Speaking', text: '每日更新英語例句，搭配線上錄音和即時語音辨識系統，讓你提升口語能力，輕鬆開口說英語！', mobiletext: '搭配線上錄音和即時語音辨識系統，讓你提升口語能力', googlelink: 'https://play.google.com/store/apps/details?id=com.LiveABC.LiveSpeaking', ioslink: 'https://apps.apple.com/tw/app/live-speaking/id1282239139' },
        { img: require('@/assets/icon/app-taipei.png'), name: '遊台灣學英語', text: '結合GPS衛星定位+AR技術，帶你用全新的方式重新認識台灣，整個城市都是你的英語智慧教室！', mobiletext: '結合GPS衛星定位+AR技術，整個城市都是你的英語智慧教室！', googlelink: 'https://play.google.com/store/apps/details?id=com.liveabc.ntc4g', ioslink: 'https://apps.apple.com/tw/app/遊新北學英語-新北市英語智慧城/id1337959562' }
      ],
      whereBuy: [
        { img: require('@/assets/icon/ebook-zinio.png'), name: 'ZINIO' },
        { img: require('@/assets/icon/ebook-google.png'), name: 'play 圖書' },
        { img: require('@/assets/icon/ebook-ebook.png'), name: '博客來電子書' },
        { img: require('@/assets/icon/ebook-pubu.png'), name: 'Pubu電子書城' },
        { img: require('@/assets/icon/ebook-udn.png'), name: 'udn 讀書吧' },
        { img: require('@/assets/icon/ebook-taaze.png'), name: 'TAAZE 讀冊' },
        { img: require('@/assets/icon/ebook-hyread.png'), name: 'HyRead<br/>讀享樂' },
        { img: require('@/assets/icon/ebook-readmoo.png'), name: 'Readmoo<br/>讀墨電子書' },
        { img: require('@/assets/icon/ebook-Kobo.png'), name: '樂天kobo<br/>電子書' },
        { img: require('@/assets/icon/ebook-hami.png'), name: '中華電信<br/>Hami書城' },
        { img: require('@/assets/icon/ebook-kono.png'), name: 'Kono<br/>電子雜誌' },
        { img: require('@/assets/icon/ebook-mybook.png'), name: '台灣大哥大<br/>myBook電子書館' }
      ]
    }
  },
  components: {
    Breadcrumb
  }
}
</script>

<style lang="scss" scoped>
  .gradient {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) -57.42%, #FFFFFF 92.08%), #EEEEEE;
    background: -moz-linear-gradient(90deg, rgba(255, 255, 255, 0) -57.42%, #FFFFFF 92.08%), #EEEEEE;
    background: -webkit-linear-gradient(90deg, rgba(255, 255, 255, 0) -57.42%, #FFFFFF 92.08%), #EEEEEE;
    background: -o-linear-gradient(90deg, rgba(255, 255, 255, 0) -57.42%, #FFFFFF 92.08%), #EEEEEE;
  }
  .title-border {
    border-top: 1px solid #163C52;
  }
  .title {
    background-color: #163C52;
  }
  img {
    object-fit: contain;
  }
</style>
